var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";
import styled from "styled-components";
import { retainValidNumbers } from "@gago/frame";
import tinycolor from "tinycolor2";
var getChartOption = function (props) {
    var _a = props.chartData, data = _a.data, prefix = _a.prefix, suffix = _a.suffix, colorPalette = props.colorPalette;
    var total = data.map(function (item) { return item[2]; }).reduce(function (item, current) { return item + current; }, 0);
    var start = 0;
    var pieData = data.map(function (item, index) {
        var color = colorPalette.subColor[index];
        var end = start + item[2];
        var middle = (start + end) / 2;
        var angle = (middle / total) * 2 * Math.PI + (((props.startAngle - 90) / 360) * 2 * Math.PI);
        var result = ({
            name: item[1],
            value: item[2],
            itemStyle: {
                /** 模拟conic-gradient，不完美，还需改进 */
                color: props.useGradient ? {
                    type: "linear",
                    x: (1 - Math.cos(angle)) / 2,
                    y: (1 - Math.sin(angle)) / 2,
                    // tslint:disable-next-line: binary-expression-operand-order
                    x2: (1 + Math.cos(angle)) / 2,
                    // tslint:disable-next-line: binary-expression-operand-order
                    y2: (1 + Math.sin(angle)) / 2,
                    colorStops: [
                        {
                            offset: 0, color: tinycolor(color).setAlpha(0.15).toRgbString(),
                        },
                        {
                            // tslint:disable-next-line: object-shorthand-properties-first
                            offset: 1, color: color,
                        },
                    ],
                    global: false,
                    /** tooltip的marker的颜色 */
                    toString: function () { return color; },
                } : color,
            },
            label: {
                normal: {
                    show: props.showLabel,
                    alignTo: props.alignTo,
                    bleedMargin: props.bleedMargin,
                    formatter: function (params) {
                        return params.name;
                    },
                    textStyle: {
                        fontSize: props.labelSize,
                        fontWeight: 400,
                        color: props.labelColor ? props.labelColor : color,
                    },
                    position: "outer",
                    margin: 0,
                },
            },
            labelLine: {
                normal: {
                    show: props.showLabel,
                    // length: 12,
                    // length2: 5,
                    lineStyle: {
                        color: props.labelLineColor ? props.labelLineColor : color,
                    },
                },
            },
            emphasis: {
                label: {
                    show: props.showLabel,
                },
                labelLine: {
                    show: props.showLabel,
                },
                itemStyle: {
                    /** 模拟conic-gradient，不完美，还需改进 */
                    color: props.useGradient ? {
                        type: "linear",
                        x: (1 - Math.cos(angle)) / 2,
                        y: (1 - Math.sin(angle)) / 2,
                        // tslint:disable-next-line: binary-expression-operand-order
                        x2: (1 + Math.cos(angle)) / 2,
                        // tslint:disable-next-line: binary-expression-operand-order
                        y2: (1 + Math.sin(angle)) / 2,
                        colorStops: [
                            {
                                offset: 0, color: tinycolor(color).setAlpha(0.4).toRgbString(),
                            },
                            {
                                // tslint:disable-next-line: object-shorthand-properties-first
                                offset: 1, color: color,
                            },
                        ],
                        global: false,
                        /** tooltip的marker的颜色 */
                        toString: function () { return color; },
                    } : color,
                },
            },
        });
        start = end;
        return result;
    });
    var refineData = pieData.reduce(function (pre, old) {
        var arr = [
            old,
        ];
        if (props.roseType !== "area" && props.gapAngle > 0) {
            arr = [
                old,
                {
                    value: (total / 360) * props.gapAngle,
                    name: "",
                    tooltip: {
                        show: false,
                    },
                    itemStyle: {
                        normal: {
                            label: {
                                show: false,
                            },
                            labelLine: {
                                show: false,
                            },
                            color: "rgba(0, 0, 0, 0)",
                            borderColor: "rgba(0, 0, 0, 0)",
                            borderWidth: 0,
                        },
                    },
                },
            ];
        }
        return pre.concat(arr);
    }, []);
    var defaultOption = {
        tooltip: {
            confine: true,
            backgroundColor: props.tooltipBackgroundColor,
            borderColor: props.tooltipBorderColor,
            borderWidth: props.tooltipBorderWidth,
            padding: 0,
            formatter: props.tooltipFormatter ? props.tooltipFormatter : function (params, ticket, callback) {
                // callback(ticket, "");
                return "<div style=\"\n          padding: " + props.labelSize + "px;\n        \">" + ((prefix && prefix[1]) ? prefix[1] : "") + params.data.name + ((suffix && suffix[1]) ? suffix[1] : "") + ": " + ((prefix && prefix[2]) ? prefix[2] : "") + Number(params.data.value) + ((suffix && suffix[2]) ? suffix[2] : "") + "<br /> \u5360\u6BD4: " + retainValidNumbers(params.value * 100 / total) + "%</div>";
            },
        },
        title: { show: false },
        series: [
            {
                name: "",
                type: "pie",
                roseType: props.roseType,
                radius: props.radius,
                avoidLabelOverlap: true,
                hoverAnimation: true,
                hoverOffset: props.hoverOffset,
                data: refineData,
                startAngle: props.startAngle,
                minAngle: props.minAngle,
                animation: true,
                animationType: "expansion",
                animationTypeUpdate: "expansion",
                animationEasing: "linear",
                animationEasingUpdate: "linear",
                animationThreshold: 2000,
                animationDuration: 1200,
                animationDurationUpdate: 1200,
            },
        ],
    };
    return defaultOption;
};
// tslint:disable-next-line: variable-name
var Root = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  overflow: visible;\n  position: relative;\n  z-index: 0;\n"], ["\n  height: 100%;\n  width: 100%;\n  overflow: visible;\n  position: relative;\n  z-index: 0;\n"])));
/**
 * 基础饼图，用于二次开发成成品饼图
 *
 * 统一了处理了以下问题
 *
 * 1.渐变色
 * 2.扇形间空白
 * 3.标签对齐
 * 4.数据处理
 * 5.tooltip
 * 6.tooltip前后缀
 * 7.布局边距
 * 8.渐变色的marker的颜色
 * 9.动画
 *
 * 带来了以下问题
 *
 * 1.图例不能互动
 *
 * @author James Zhang
 */
// tslint:disable-next-line: naming-convention
export function PieChart(props) {
    return useMemo(function () {
        var style = props.style, className = props.className, onChartReady = props.onChartReady;
        var option = getChartOption(props);
        return (React.createElement(Root, { style: style, className: className },
            React.createElement(ReactEcharts, { notMerge: false, style: { height: "100%", width: "100%" }, option: option, onChartReady: onChartReady }),
            props.children));
    }, getDependencies(props));
}
PieChart.defaultProps = {
    onChartReady: function () { return null; },
    labelSize: 14,
    children: null,
    useGradient: false,
    radius: ["0%", "90%"],
    hoverOffset: 8,
    startAngle: 90,
    alignTo: "edge",
    roseType: false,
    showLabel: true,
    gapAngle: 0,
    minAngle: 0,
};
/** 获取用于`useMemo`的依赖
 * @author James Zhang
 */
export function getDependencies(props) {
    var keys = Object.keys(props).sort();
    return keys.map(function (key) { return props[key]; });
}
/** 获取提示框格式化函数 */
export function getToolTipFormater(props, showPercent) {
    if (showPercent === void 0) { showPercent = false; }
    var _a = props.chartStyle, mainTextColor = _a.mainTextColor, mainTextSize = _a.mainTextSize, mainAxisColor = _a.mainAxisColor, secondaryTextColor = _a.secondaryTextColor, secondaryTextSize = _a.secondaryTextSize, secondaryAxisColor = _a.secondaryAxisColor, tooltipMainTextColor = _a.tooltipMainTextColor, tooltipSecondaryTextColor = _a.tooltipSecondaryTextColor, splitLineColor = _a.splitLineColor;
    var prefix = props.chartData.prefix;
    var suffix = props.chartData.suffix;
    var total = props.chartData.data.map(function (item) { return item[2]; }).reduce(function (item, current) { return item + current; }, 0);
    var namePrefix = (prefix && prefix[1]) ? prefix[1] : "";
    var nameSuffix = (suffix && suffix[1]) ? suffix[1] : "";
    var dataPrefix = (prefix && prefix[2]) ? prefix[2] : "";
    var dataSuffix = (suffix && suffix[2]) ? suffix[2] : "";
    var tooltipFormater = function (params) {
        return "\n      <div style=\"padding: " + mainTextSize + "px;line-height:" + mainTextSize * 2 + "px;\">\n        <span style=\"\n          color:" + tooltipSecondaryTextColor + ";\n          font-size:" + mainTextSize + "px;\n        \">\n          " + params.marker + "&nbsp;" + namePrefix + params.data.name + nameSuffix + "\n        </span>\n        <br>\n        <span style=\"\n          color:" + tooltipSecondaryTextColor + ";\n          font-size:" + mainTextSize + "px;\n        \">" + props.chartData.head[2] + "</span>\n        <span style=\"\n          color:" + tooltipMainTextColor + ";\n          font-size:" + mainTextSize + "px;\n        \">&nbsp;&nbsp;&nbsp;&nbsp;" + dataPrefix + params.data.value + dataSuffix + "</span>\n        " + (showPercent ? "\n          <br>\n          <span style=\"\n            color:" + tooltipSecondaryTextColor + ";\n            font-size:" + mainTextSize + "px;\n          \">\u5360\u6BD4</span>\n          <span style=\"\n            color:" + tooltipMainTextColor + ";\n            font-size:" + mainTextSize + "px;\n          \">&nbsp;&nbsp;&nbsp;&nbsp;" + retainValidNumbers(params.value * 100 / total) + "%</span>" :
            "") + "\n      </div>\n    ";
    };
    return tooltipFormater;
}
var templateObject_1;
//# sourceMappingURL=index.js.map